import React, { forwardRef } from 'react'

import { IconProps } from './types'

const MinusCircle = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_511_245)">
        <path
          d="M5 8L11 8M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
          stroke={color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_511_245">
          <rect width={size} height={size} fill="none" />
        </clipPath>
      </defs>
    </svg>
  ),
)

MinusCircle.displayName = 'MinusCircle'

MinusCircle.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default MinusCircle
